import Repository from '../Repository';

const url = '/admin/livestream/announcements';

export default {
    get(id) {
        return Repository.get(`${url}/${id}`, {localLoading: true});
    },

    getAll(page = 1) {
        return Repository.get(`${url}?page=${page}`, {localLoading: true});
    },

    getUpcoming(page = 1) {
        return Repository.get(`${url}?type=upcoming&page=${page}`, {localLoading: true});
    },

    getPast(page = 1) {
        return Repository.get(`${url}?type=past&page=${page}`, {localLoading: true});
    },

    create(payload) {
        return Repository.post(`${url}/`, payload, {localLoading: true});
    },

    update(id, payload) {
        return Repository.patch(`${url}/${id}`, payload, {localLoading: true});
    },

    delete(id) {
        return Repository.delete(`${url}/${id}`,{localLoading: true});
    },
}
